"use client";

import { usePathname } from "next/navigation";
import { splitLocale } from "@/lib/i18n";

/** The page's path without its language prefix ("/de/videos" → "/videos"), for comparing with site paths. */
export function useSitePath(): string {
  return splitLocale(usePathname()).path;
}
